module.exports = __webpack_public_path__ + "static/media/banner_ext_pf.fdd14661.svg";